export default __webpack_public_path__ + "static/bridgephase-boston-holiday-party-2019-71ca902c18dce5cb7d11393aad2b414c.jpg";